import t from "./internal/_curry1.mjs";
var o = /* @__PURE__ */ t(function(e) {
  return e === null ? "Null" : e === void 0 ? "Undefined" : Object.prototype.toString.call(e).slice(8, -1);
});
export {
  o as default
};
